const STORAGE_KEY = 'propostasDCO';

export function salvarAuto(proposta) {
  if (!proposta?.nomeProjeto) return;

  const propostas = listarPropostas();
  const semAtual = propostas.filter(p => p.id !== proposta.id);
  const nova = {
    ...proposta,
    dataCriacao: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...semAtual, nova]));
}

export function listarPropostas() {
  const propostas = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  const agora = new Date();

  const validas = propostas.filter((p) => {
    const dias = (agora - new Date(p.dataCriacao)) / (1000 * 60 * 60 * 24);
    return dias <= 14;
  });

  if (validas.length !== propostas.length) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(validas));
  }

  return validas;
}

export function obterPropostaPorId(id) {
  return listarPropostas().find((p) => p.id === id);
}

export function excluirProposta(id) {
  const restantes = listarPropostas().filter((p) => p.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(restantes));
}
